// How much the timeline draws by default (2026-10-05 report: "the little
// timeline thing is just gross, it's just busy"). Simple is bars, target
// diamonds and the today line; Full adds the decision diamonds, movement
// ticks, outside-blocker hatching, dependency arrows and the check-in line.
// Nothing is removed: Full is one click away and the choice is remembered per
// browser. Storage is guarded the same way as roadmapIntro.ts.

export type DetailMode = 'simple' | 'full';

export const DETAIL_KEY = 'roadmap.timelineDetail';
export const DEFAULT_DETAIL: DetailMode = 'simple';

export const DETAIL_LABELS: Record<DetailMode, string> = {
  simple: 'Simple',
  full: 'Full detail',
};

type StorageLike = Pick<Storage, 'getItem' | 'setItem'>;

function storage(): StorageLike | null {
  try {
    return typeof window !== 'undefined' && window.localStorage ? window.localStorage : null;
  } catch {
    return null;
  }
}

/** The remembered choice; Simple when nothing valid is stored or storage is unavailable. */
export function readDetail(store: StorageLike | null = storage()): DetailMode {
  try {
    const v = store?.getItem(DETAIL_KEY);
    return v === 'simple' || v === 'full' ? v : DEFAULT_DETAIL;
  } catch {
    return DEFAULT_DETAIL;
  }
}

export function writeDetail(mode: DetailMode, store: StorageLike | null = storage()): void {
  try {
    store?.setItem(DETAIL_KEY, mode);
  } catch {
    // storage blocked: the chart simply opens on Simple next visit
  }
}
